import { axios, AxiosResponse } from "@sdk/axios";
import { SDKConfig } from "@sdk/default-sdk-config";
import { iOrganization } from "@sdk/user-management/user-management.models";

import { UserTracker } from "user-tracker";
import { iNewsFeedType } from "./newsfeed-model";

export class NewsfeedTypesServices {
  configure(config: { basePath?: string; token?: string }) {
    Object.assign(this.config, config);
  }
  constructor(protected config: { basePath: string; token: string }) {
    this.newsfeedTypes.config = config;
  }

  newsfeedTypes = Object.assign(
    { config: SDKConfig },
    {
      addNewsFeedType: async (data: iNewsFeedType) => {
        UserTracker.track("NEWSFEED_TYPES - Add NEWSFEED_TYPES", {});
        const results: AxiosResponse<iOrganization> = await axios.post(
          this.config.basePath + `/organizations/newsfeed-types`,
          data,
          {
            headers: {
              Authorization: this.config.token,
            },
          },
        );
        return results.data;
      },
      editNewsFeedType: async (id: string, data: iNewsFeedType) => {
        UserTracker.track("NEWSFEED_TYPES - Edit NEWSFEED_TYPES", {});
        const results: AxiosResponse<iOrganization> = await axios.patch(
          this.config.basePath + `/organizations/newsfeed-types/${id}`,
          data,
          {
            headers: {
              Authorization: this.config.token,
            },
          },
        );
        return results.data;
      },
      deleteNewsFeedType: async (id: string) => {
        UserTracker.track("NEWSFEED_TYPES - Delete NEWSFEED_TYPES", {});
        const results: AxiosResponse<iOrganization> = await axios.delete(
          this.config.basePath + `/organizations/newsfeed-types/${id}`,
          {
            headers: {
              Authorization: this.config.token,
            },
          },
        );
        return results.data;
      },
    },
  );
}
